// @core/api/endpoints/webhook/resolve_webhook_context.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ResolveWebhookContextRequest,
  ResolveWebhookContextResponse,
} from '../../../types/webhook';

const BASE_PATH = '/webhook';

/**
 * Resolve webhook context
 * Resolves the effective webhook policy for a scope entity by merging the policy hierarchy.
 */
export async function ResolveWebhookContext(
  data: ResolveWebhookContextRequest,
  options?: RequestOptions
): Promise<ResolveWebhookContextResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/webhooks/resolve-context`;
  const requestOptions = options;
  return client.post<ResolveWebhookContextResponse>(requestPath, data, requestOptions);
}
